import { useTranslate } from "@growtherapy/i18n";
import { Text } from "@growtherapy/sprout-ui";
import { faCircleMinus } from "@fortawesome/pro-solid-svg-icons";
import { ModifiedToastAria, Toast, ToastVariant } from "../../toasts";

export function ConsentDeclinedToast({
  contentProps,
  descriptionProps,
  titleProps,
  visitorDeclinedConsent,
  ...toastAriaProps
}: ModifiedToastAria & { visitorDeclinedConsent: boolean }) {
  const t = useTranslate();

  return (
    <Toast
      {...toastAriaProps}
      aria-live="assertive"
      variant={ToastVariant.Info}
      icon={faCircleMinus}
    >
      <div {...contentProps}>
        <span className="sr-only" {...titleProps}>
          {t("telehealth-core:consent.consentDeclined")}
        </span>
        <Text as="span" {...descriptionProps}>
          {visitorDeclinedConsent
            ? t(
                "telehealth-core:consent.weveLetYourProviderKnowAndSavedYourConsentSetting",
              )
            : t(
                "telehealth-core:consent.anotherParticipantHasDeclinedToConsentToTranscription",
              )}
        </Text>
      </div>
    </Toast>
  );
}
